import React, { useEffect, useState } from 'react';
import { AxiosError, AxiosResponse } from 'axios';
import { Alert, Button } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import ApiService from '../../services/ApiService';
import Form from '../form/Form';
import toast from '../toastr';
import { modal } from '../modal/ModalEmitter';
import { getInfo } from '../../actions/AppActions';

interface Props {
  branchId: number;
  onCancel?: () => void;
  onSubmit?: (data: object) => any;
  onError?: (err: Error) => any;
}

const getLayout = (branch: any) => {
  return [
    {
      type: 'section',
      label: 'Payments',
      fields: [
        {
          name: 'payment.publicKey',
          label: 'Public Key (Card Not Present)',
          data: branch.payment.publicKey,
        },
        {
          name: 'payment.privateKey',
          label: 'Private Key (Card Not Present)',
          data: branch.payment.privateKey,
        },
        {
          name: 'payment.processorId',
          label: 'Processor ID',
          data: branch.payment.processorId,
        },
        {
          name: 'payment.resellerName',
          label: 'Reseller Name (Terminals)',
          data: branch.payment.resellerName,
        },
        {
          col: 6,
          name: 'payment.enabled',
          label: 'Enabled',
          type: 'boolean',
          control: 'checkbox',
          options: [true, false],
          data: branch.payment.enabled,
        },
        {
          col: 6,
          name: 'payment.saveCard',
          label: 'Save Card By Default',
          type: 'boolean',
          control: 'checkbox',
          options: [true, false],
          data: branch.payment.saveCard,
        },
      ],
    },
  ];
};

const PaymentSetupForm = ({ branchId, onSubmit = () => null, onError = () => null, onCancel = () => null }: Props) => {
  const user = useSelector((state: any) => state.app.user);
  const dispatch = useDispatch();

  const [branch, setBranch] = useState<any>(null);

  if (branch && !branch.payment) {
    branch.payment = {};
  }

  useEffect(() => {
    ApiService.get(`/db/UST2/${branchId}`).then((response: AxiosResponse) => {
      setBranch(response.data);
    });
  }, [branchId]);

  const handleSubmit = (data: any) => {
    ApiService.put(`/db/UST2/${branchId}`, data)
      .then((response: AxiosResponse) => {
        dispatch(getInfo());
        onSubmit(response.data);
      })
      .catch((err: AxiosError) => {
        toast.error(err.message);
        onError(err);
      });
  };

  const handleSwitchBranch = () => {
    modal.open('changeBranch');
  };

  const renderAlert = () => {
    if (user.branches.length < 1) {
      return null;
    }

    return (
      <Alert variant="warning">
        <Alert.Heading>Warning</Alert.Heading>
        <p>All configuration values are per branch. Switch branches to configure a different branch. </p>
        <hr />
        <Button variant="secondary" size="sm" onClick={handleSwitchBranch}>
          Switch Branch
        </Button>
      </Alert>
    );
  };

  if (!branch) {
    return null;
  }

  return (
    <>
      {renderAlert()}
      <Form
        layout={getLayout(branch)}
        submit={handleSubmit}
        onCancel={onCancel}
        exportFormat="object"
        showHelp
        submitAll
      />
    </>
  );
};

export default PaymentSetupForm;
